import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from './Context/AuthContext';
import { BookProvider } from './Context/BookContext';
import theme from './theme';
import App from './App';
import awsExports from './aws-exports';
import './index.css';

// Configure Amplify
Amplify.configure(awsExports);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BookProvider>
          <App />
        </BookProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
); 